import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container } from "reactstrap";
import { useHistory } from 'react-router-dom';
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    Badge,
    Form,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Alert
  } from "reactstrap"
  import { Link } from "react-router-dom"
  //Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


import axios from 'axios';
import { HRConfig, formatDate, TOAST_OPTIONS } from "../../helpers/backend_helper"
import { EXIT_INTERVIEWS } from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
   
    const ExitInterviews = () => {
      const history = useHistory()
      toastr.options = TOAST_OPTIONS;
      const [eIList, setEIList] = useState([])
      const [isLoading, setIsLoading] = useState(false)
      const [empNo, setEmpNo] = useState('')
      const [empName, setEmpName] = useState('')
      const [empTitle, setEmpTitle] = useState('')
      const [postingDate, setPostingDate] = useState(new Date())

      const getData = () =>{
        setIsLoading(true)
        if (localStorage.getItem("authMildUser")) {
            const obj = JSON.parse(localStorage.getItem("authMildUser"));
            setEmpNo(obj.uid)
            setEmpName(obj.username)
            let EmployeeNo = obj.uid;
            axios.get(EXIT_INTERVIEWS+"?$filter=employeeNo eq '"+EmployeeNo+"'&company="+ obj.activeCompany, HRConfig).then((r)=>{ 
              setIsLoading(false)
              setEIList(r.data.value)
          }).catch((e)=>{ console.log(e); setIsLoading(false); 
          })
        }
      }
      useEffect(()=>{
        getData()
      },[])
      const { SearchBar } = Search;
      const columns = [
      {
        dataField: 'no',
        text: 'Exit No',
        sort: true,
        formatter: noFormatter
      },
      {
        dataField: 'employeeNo',
        text: 'Employee No',
        sort: true
      }, 
      {
        dataField: 'employeeName',
        text: 'Name',
        sort: true
      },  
      {
        dataField: 'positionName',
        text: 'Position',
        sort: true
      }, 
      {
        dataField: 'dateOfLastWorking',
        text: 'Last Working Date',
        sort: true
      },
      {
        dataField: 'status',
        text: 'Status',
        sort: true,
        formatter: statusFormatter
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "",
        formatter: actionFormatter
      }];

      const defaultSorted = [{
        dataField: 'no',
        order: 'desc'
      }];

      function noFormatter(cellContent, row){
        return(
          <strong>{cellContent}</strong>
        )
      }

      function actionFormatter(cellContent, row){
        return(
         <>
            <div className="d-flex gap-3">
            <UncontrolledDropdown direction="left">
                <DropdownToggle href="#" className="card-drop" tag="i">
                  <i className="mdi mdi-dots-horizontal font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    onClick={()=>{ history.push(`/exit-interview-details/${row.SystemId}`); }}
                  >
                    <i className="fas fa-address-card text-warning me-1" />
                    View Interview Details
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </>
        )
      }
      function statusFormatter(cellContent, row) {
        if (row.status == "Submitted to HR") {
          return (
            <div>
                <Badge className="me-2 bg-warning">
                { cellContent }
                </Badge>
            </div>
          );
        }else if (row.status == "Approved"){
          return (
            <div>
                <Badge className="me-2 bg-success">
                { cellContent }
                </Badge>
            </div>
          );
        }else{
          return (
            <div>
                <Badge className="me-2 bg-danger">
                { cellContent }
                </Badge>
            </div>
          );
        }
      }

        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Exit Interviews | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                      <Breadcrumbs title="Human Resource Management" breadcrumbItem="Exit Interviews" />                           
                        <Row>
                        <Col lg={12}>
                            {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                          </Col>
                          <Col xl={12}>
                              <Card>
                                <CardBody>
                                {eIList && (eIList.length > 0) && (<>
                                  <ToolkitProvider
                                      keyField="no"
                                      data={ eIList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row className="mb-5">
                                              <Col lg="8">
                                                <div className="rounded bg-light d-grid gap-2">
                                                    <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0"/>
                                                </div>
                                              </Col>

                                              <Col lg="4">
                                                <div className="d-grid gap-2">
                                                  <Link
                                                    className="btn btn-primary"
                                                    to="/create-exit-interview"
                                                  >
                                                    <i className="mdi mdi-plus me-1" />
                                                    Create Exit Interview
                                                  </Link>
                                                </div>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='no' 
                                                  data={ eIList } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-wrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                          </Col>
                                        </Row>
                                      </React.Fragment>      
                                    )}
                                  </ToolkitProvider>
                                </>
                              )
                            }
                          {eIList && (eIList.length < 1) && ( <>
                            <Row className="d-flex justify-content-center">
                            <Col lg={8} >
                              <div className="text-center">
                                <div className="mb-4">
                                  <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                </div>
                                <div>
                                  <h5>No Exit Interview Found</h5>
                                </div>
                              </div>
                              <div className="text-center mt-4">
                                <Link
                                  to="/create-exit-interview"
                                  className="btn btn-primary  btn-sm"
                                >
                                  Create Exit Interview <i className="mdi mdi-arrow-right ms-1" />
                                </Link>
                              </div>
                            </Col>
                          </Row>
                        </>
                      )
                    }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
  }

export default ExitInterviews;